<template>
    <div class="content">
        <div class="content_box tableParent public_box">
            <div class="search_box" v-if="!isPlugDetail">
                <!--检索部分-->
                <el-form ref="formRef" :inline="true" :model="navForm">
                    <el-form-item label="车牌号/车架号/设备编号:" prop="condition.keyWord">
                        <el-input class="width_200" v-model="navForm.condition.keyWord" size="small" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="运营公司:" prop="condition.cascaderVal">
                        <el-cascader
                            ref="companyRef"
                            popper-class="cascaderStyle"
                            v-model="navForm.condition.cascaderVal"
                            :options="cascCaderOptions"
                            :props="cascCaderProps"
                            placeholder="请选择"
                            :show-all-levels="false"
                            size="small"
                            filterable
                            clearable
                            @change="(e) => handleSelectCost(1, e)"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="车辆状态:" prop="condition.vehicleStatus">
                        <el-select class="width_90" v-model="navForm.condition.vehicleStatus" placeholder="请选择" size="small" clearable>
                            <el-option v-for="(item, index) in vehicleStatusOptions" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备状态:" prop="condition.deviceStatus">
                        <el-select class="width_90" v-model="navForm.condition.deviceStatus" placeholder="请选择" size="small" clearable>
                            <el-option v-for="(item, index) in deviceStatusOptions" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产品类型:" prop="condition.deviceType" v-if="productTypeData && productTypeData.length > 1">
                        <el-select v-model="navForm.condition.deviceType" placeholder="请选择" size="small" class="width_150">
                            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.dictName" :value="item.metaData"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 单摄/双摄 shortTermRental 由前端自动注入，无需用户选择 -->
                    <el-form-item label="短租车:" prop="condition.shortTermRental" v-if="false">
                        <el-select class="width_120" v-model="navForm.condition.shortTermRental" placeholder="全部" size="small" clearable>
                            <el-option label="全部" :value="null"></el-option>
                            <el-option label="短租车" :value="true"></el-option>
                            <el-option label="非短租车" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="激活时间：" prop="condition.value1">
                        <el-date-picker
                            class="forceWidth_320"
                            @change="datePickerChange1"
                            size="small"
                            v-model="navForm.condition.value1"
                            type="datetimerange"
                            align="right"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="到期时间：" prop="condition.value2">
                        <el-date-picker
                            class="forceWidth_320"
                            @change="datePickerChange2"
                            size="small"
                            v-model="navForm.condition.value2"
                            type="datetimerange"
                            align="right"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="queryBtn" type="primary" size="small" @click="queryListData" style="margin-left: 0.2rem">查询</el-button>
                        <el-button class="queryBtn" type="warning" size="small" @click="resetQuery" style="margin-left: 0.2rem">重置</el-button>
                        <el-button class="queryBtn" type="primary" size="small" @click="handleDownload" style="margin-left: 0.2rem">下载</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!--table表格部分-->
            <el-table ref="multipleTable" class="tableHeightAdaptive" :data="tableData" v-loading="tableLoading" @sort-change="sortChange">
                <el-table-column prop="plateNo" label="车牌号" width="110"></el-table-column>
                <el-table-column prop="deviceNumber" label="设备编号" width="120"></el-table-column>
                <el-table-column prop="vin" label="车架号" width="180"></el-table-column>
                <el-table-column prop="totalTripsNum" label="行程数"></el-table-column>
                <el-table-column prop="totalDrivingDuration" label="驾驶时长(h)"> </el-table-column>
                <el-table-column prop="activationStatusName" label="激活状态"></el-table-column>
                <el-table-column prop="subTenantName" label="运营公司">
                    <template slot-scope="scope">
                        <overflow-txt :txt="scope.row.subTenantName"></overflow-txt>
                    </template>
                </el-table-column>
                <el-table-column prop="bindStatusName" label="设备状态"></el-table-column>
                <el-table-column prop="onlineStatusName" label="车辆状态"></el-table-column>
                <el-table-column label="操作" width="150px">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="handleLookDetail(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页部分-->
            <el-pagination style="margin-top: 0.2rem" @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page="navForm.pageNo" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20]" :page-size="navForm.pageSize" :total="navForm.pageTotal">
            </el-pagination>
            <!-- 案件详情 -->
            <el-dialog class="dialog-title_style" :visible.sync="dialogVisible" width="1100px" :modal-append-to-body="false">
                <device-detail :detailForm="detailForm"></device-detail>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import OSS from 'ali-oss';
import DeviceDetail from '@/components/DeviceDetail.vue';
let _this;
export default {
    components: { DeviceDetail },
    data() {
        return {
            fullscreenLoading: null,
            tableLoading: false,
            tmpSource: null,
            OSSClient: null,
            dialogVisible: false,
            previewLoading: true,
            currentItem: '',
            activeImgIndex: 0,
            imgList: [],
            isPlugDetail: false,
            attachmentRow: {
                device: '17716532123',
                totalTripsNum: '侧翻碰撞告警',
                startTime: '2022-11-07 17:09:23'
            },
            tableHeight: window.innerHeight > 760 ? 507 : 342,
            plubHeight: window.innerHeight > 760 ? 507 : 500,
            initialDataLoaded: false,
            rid: '',
            loading: false,
            center: { lng: 116.404269, lat: 39.915378 },
            zoom: 18,
            BDmap: '',
            BMap: '',
            batchIdList: [], //车队
            queryTime: null,
            navForm: {
                condition: {
                    value1: null,
                    value2: null,
                    vehicleStatus: null,
                    alarmType: 0,
                    companyId: null,
                    deviceType: null,
                    endBindTime: null,
                    endExpirationTime: null,
                    endTime: null,
                    keyWord: '',
                    startBindTime: null,
                    startExpirationTime: null,
                    startTime: null,
                    deviceStatus: null,
                    shortTermRental: null
                },
                orders: [],
                pageNo: 1,
                pageSize: 10,
                pageTotal: 0
            },
            marker: { showFlag: false },
            currentPage: 1, //当前页
            pageSize: 10, //一页多少条数据
            totalPage: 1, //总页数tableData:[],
            tableData: [],
            companyList: [],
            deviceQueryData: {},
            cascCaderProps: {
                children: 'subTenantTreeLists',
                label: 'tenantName',
                value: 'tenantId',
                expandTrigger: 'hover',
                checkStrictly: true
            },
            detailForm: null,
            vehicleDetailData: null,
            deviceStatusOptions: [
                {
                    label: '已安装',
                    value: 0
                },
                {
                    label: '已过期',
                    value: 1
                }
            ],
            vehicleStatusOptions: [
                {
                    label: '在线',
                    value: 1
                },
                {
                    label: '离线',
                    value: 2
                }
            ]
        };
    },
    computed: {
        productTypeData() {
            let typeData = this.$store.state.common.productTypeData;
            if (typeData && typeData.length) {
                let expandItem = typeData.find((item) => item.expandInfo);
                if (this.navForm.condition.deviceType == null) {
                    let defaultType = expandItem ? expandItem.metaData : typeData[0].metaData;
                    this.navForm.condition.deviceType = defaultType;
                }
            }
            return typeData;
        },
        cascCaderOptions() {
            return this.$store.state.common.companyTreeData;
        }
    },
    mounted() {
        this.tryInitialLoad();

        // if (this.$route.query && this.$route.query.item) {
        //     let queryData = JSON.parse(this.$route.query.item);
        //     this.setQueryTime(1);
        //     this.navForm.condition.search = queryData.plateNo;
        // } else {
        //     this.setQueryTime(2);
        // }
    },
    activated() {
        this.tryInitialLoad();
    },
    methods: {
        tryInitialLoad() {
            if (this.initialDataLoaded || this.tableLoading || this.tableData.length > 0) {
                return;
            }
            const typeData = this.productTypeData;
            if (Array.isArray(typeData) && typeData.length && this.navForm.condition.deviceType == null) {
                const expandItem = typeData.find((item) => item.expandInfo);
                const defaultType = expandItem ? expandItem.metaData : typeData[0].metaData;
                this.navForm.condition.deviceType = defaultType;
            }
            if (!Array.isArray(typeData) || !typeData.length) {
                return;
            }
            this.initialDataLoaded = true;
            this.queryListData();
        },
        datePickerChange1(val) {
            if (val.length > 1) {
                this.navForm.condition.startTime = val[0];
                this.navForm.condition.endTime = val[1];
            } else {
                this.navForm.condition.startTime = null;
                this.navForm.condition.endTime = null;
            }
        },
        datePickerChange2(val) {
            if (val.length > 1) {
                this.navForm.condition.startExpirationTime = val[0];
                this.navForm.condition.endExpirationTime = val[1];
            } else {
                this.navForm.condition.startExpirationTime = null;
                this.navForm.condition.endExpirationTime = null;
            }
        },
        //点击查看详情
        handleLookDetail(rowItem) {
            this.dialogVisible = true;
            // this.$emit('update:messageParent', true);
            const currentDeviceType = this.navForm.condition.deviceType;
            const apiDeviceType = currentDeviceType == 2 ? 1 : currentDeviceType;
            this.$request({ method: 'get', url: `/ubi/api/vehicle/vehicleDetail`, params: { deviceType: apiDeviceType, keyWord: rowItem.deviceNumber } }).then((res) => {
                if (res.code == 200) {
                    this.vehicleDetailData = res.data;
                    this.detailForm = res.data;
                    this.detailForm.deviceType = currentDeviceType;
                    this.detailForm.alarmCount = rowItem.alarmCount || 0;
                }
            });
        },
        openNewPage(row) {
            let routeUrl = this.$router.resolve({
                path: '/vehicle/vehicleDetail',
                query: {
                    deviceType: this.navForm.condition.deviceType,
                    deviceNumber: row.deviceNumber
                }
            });
            window.open(routeUrl.href, '_blank');
        },
        setQueryTime(day) {
            let days = this.getLastNDays(day);
            if (days.length == 1) {
                this.queryTime = [`${days[0]} 00:00:00`, `${days[0]} 23:59:59`];
            } else {
                this.queryTime = [`${days[1]} 00:00:00`, `${days[0]} 23:59:59`];
            }
            this.queryTimeChange();
        },
        getLastNDays(n) {
            const dates = [];

            for (let i = 0; i < n; i++) {
                const currentDate = new Date();
                currentDate.setDate(currentDate.getDate() - i);

                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');

                dates.push(`${year}-${month}-${day}`);
            }

            return dates;
        },
        handleSelectCost(type, val) {
            this.navForm.condition.companyId = val && val.length > 0 ? val[val.length - 1] : null;
            this.$refs.companyRef.dropDownVisible = false;
        },
        loadCompanyList() {
            return new Promise((resolve, reject) => {
                this.instance.get('/ubi/api/tenant/companyList', { params: {} }).then((res) => {
                    if (res.code == 200 && data.data) {
                        resolve(data.data);
                    }
                });
            });
        },
        loadFleetList(id) {
            return new Promise((resolve, reject) => {
                this.instance.get('/ubi/api/tenant/fleetList?companyId=' + id).then((res) => {
                    if (res.code == 200 && data.data) {
                        data.data.forEach((item) => {
                            item.name = item.customerId;
                            // item.leaf = true;
                        });
                        resolve(data.data);
                    }
                });
            });
        },
        loadLastList(id) {
            return new Promise((resolve, reject) => {
                this.instance.get('/ubi/api/tenant/fleetList?companyId=' + id).then((res) => {
                    if (res.code == 200 && data.data) {
                        data.data.forEach((item) => {
                            item.name = item.customerId;
                            item.leaf = true;
                        });
                        resolve(data.data);
                    } else {
                        resolve();
                    }
                });
            });
        },
        //获取分公司
        getCompanyList() {
            this.instance.get('/ubi/api/tenant/companyList').then((res) => {
                if (res.code == 200) {
                    this.companyList = data.data;
                }
            });
        },
        sortChange(column) {
            let tmpIndex = this.navForm.orders.findIndex((res) => {
                return res.column == column.prop;
            });
            let tmpOrderItem = {
                asc: column.order == 'ascending' ? true : false,
                column: column.prop
            };
            this.navForm.orders = [];
            this.navForm.orders.push(tmpOrderItem);
            column.order && this.navForm.orders.push(tmpOrderItem);
            this.getTableData();
        },
        //重新计算index序号
        hIndex(index) {
            // index索引从零开始，index +1即为当前数据序号
            this.currentPage <= 0 ? (this.currentPage = 1) : this.currentPage;
            // 如果当前不是第一页数据
            if (this.currentPage != 1) {
                // index + 1 + (( 当前页 - 1) * 每页展示条数)
                // 比如是第二页数据 1 + ((2 - 1)*5) = 6,第二页数据也就是从序号6开始
                return index + 1 + (this.currentPage - 1) * this.pageSize;
            }
            // 否则直接返回索引+1作为序号
            return index + 1;
        },

        handleDownload() {
            this.fullscreenLoading = this.$loading({
                lock: true,
                text: '下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let downloadData = JSON.parse(JSON.stringify(this.navForm));
            if (downloadData.condition.deviceType == 2) {
                downloadData.condition.deviceType = 1;
                downloadData.condition.shortTermRental = true;
            } else if (downloadData.condition.deviceType == 1) {
                downloadData.condition.shortTermRental = false;
            }
            downloadData.pageNo = 1;
            downloadData.pageSize = 100000;

            this.$download({ method: 'post', url: '/ubi/api/vehicle/vehiclePageDownload', data: downloadData })
                .then((res) => {
                    this.fullscreenLoading.close();
                    let nowDate = this.$$dateFormatting(new Date(), 'yyyy年MM月dd日');
                    const typeNameMap = { 0: 'OBD', 1: '双摄', 2: '单摄' };
                    let typeName = typeNameMap[this.navForm.condition.deviceType] || 'OBD';
                    let downloadName = nowDate + typeName + '设备统计清单.xlsx';

                    let fileName = this.$$parseFileName(res.headers['content-disposition']) || downloadName;
                    this.$$exportFile(res.data, fileName);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        //点击查询
        queryListData() {
            this.navForm.pageNo = 1;
            this.getTableData();
        },
        resetQuery() {
            this.$refs.formRef.resetFields();
            this.navForm.condition.startTime = null;
            this.navForm.condition.endTime = null;
            this.navForm.condition.startExpirationTime = null;
            this.navForm.condition.endExpirationTime = null;
        },
        getTableData() {
            this.tableLoading = true;
            let requestData = JSON.parse(JSON.stringify(this.navForm));
            if (requestData.condition.deviceType == 2) {
                requestData.condition.deviceType = 1;
                requestData.condition.shortTermRental = true;
            } else if (requestData.condition.deviceType == 1) {
                requestData.condition.shortTermRental = false;
            }
            this.$request({ method: 'POST', url: '/ubi/api/vehicle/vehiclePage', data: requestData }).then((res) => {
                this.tableLoading = false;
                if (res.code == 200) {
                    this.tableData = res.data.list;
                    this.navForm.pageTotal = res.data.total;
                } else {
                    this.navForm.pageTotal = 0;
                }
            });
        },
        queryTimeChange() {
            if (this.queryTime) {
                this.navForm.condition.startTime = this.queryTime[0];
                this.navForm.condition.endTime = this.queryTime[1];
            } else {
                this.navForm.condition.startTime = null;
                this.navForm.condition.endTime = null;
            }
        },
        //分页数据多少条change
        handleSizeChange(val) {
            this.navForm.pageSize = val;
            this.getTableData();
        },
        //分页：当前页改变之后的函数
        handleCurrentChange(val) {
            this.navForm.pageNo = val;
            this.getTableData();
        }
    },
    watch: {
        productTypeData: {
            handler(val) {
                this.tryInitialLoad();
            },
            immediate: true
        }
    }
};
</script>
<style lang="less" scoped>
.content {
    position: relative;
    height: 100%;
}
.search_box {
    margin-bottom: 20px;
    .form_time {
        width: 350px !important;
        padding-right: 0;
    }
}
.search_box .el-form--inline .el-form-item {
    margin-bottom: 10px;
}
#container,
#conta {
    width: 100%;
    height: 500px;
}
#container /deep/ .BMap_pop {
    left: 264px !important;
    top: 90px !important;
}
#container /deep/ .BMap_pop p {
    line-height: 18px;
}
#container /deep/ .BMap_pop p:nth-child(3) {
    display: inline-block;
    width: 300px;
}
.content {
    position: relative;
    .back_btn {
        position: absolute;
        right: 0px;
        top: -5px;
    }
}
.maxHeight {
    height: 600px !important;
}
.minHeight {
    height: 455px !important;
}

.attachment_dialog {
    /deep/ .el-dialog__body {
        padding-top: 0;
    }
    .dialog_title {
        span {
            color: #333;
            font-size: 16px;
        }
        .warning_type {
            margin: 0 30px;
        }
    }
    .attachment_box {
        height: 550px;
        .box_left {
            width: 780px;
            height: 550px;
            padding-right: 40px;
            border-right: 1px solid #8b8b8b;
            video {
                width: 100%;
                height: 100%;
                // border: 1px solid #ccc;
            }
        }
        .box_right {
            width: 170px;
            height: 550px;
            overflow-y: auto;
            // margin-right: 20px;
            text-align: center;
            padding-left: 25px;
            li {
                width: 120px;
                height: 120px;
                border: 1px solid #ccc;
                margin-bottom: 20px;
                cursor: pointer;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
                video {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            li:last-child {
                margin-bottom: 0;
            }
            .subsetActive {
                border: 2px solid red !important;
            }
        }
    }
}
</style>


<style lang="less">
</style>
